import { createSelector } from 'reselect';

// Config
import { postcodesAffected } from './JerseyMessage';
import { getSelectedCollectionPointPostcodeSelector } from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import {
  getConfirmedDeliveryAddressPostcodeSelector,
  getSelectedDeliveryChoiceIdSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { isClickAndCollectChoice, isDeliveryChoice } from '@utils/delivery/deliveryHelper';

const jerseyMessageState = createSelector(
  [
    getSelectedDeliveryChoiceIdSelector,
    getConfirmedDeliveryAddressPostcodeSelector,
    getSelectedCollectionPointPostcodeSelector,
  ],
  (selectedDeliveryChoiceId, deliveryPostcode = '', clickAndCollectPostcode = '') => {
    const isDelivery = isDeliveryChoice(selectedDeliveryChoiceId);
    const isClickAndCollect = isClickAndCollectChoice(selectedDeliveryChoiceId);

    let postcode = '';
    if (isDelivery) {
      postcode = deliveryPostcode;
    } else if (isClickAndCollect) {
      postcode = clickAndCollectPostcode;
    }

    if (postcode) {
      return postcodesAffected.includes(postcode.substring(0, 3));
    }

    return false;
  },
);

export default jerseyMessageState;
